import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ScheduleDialogService} from "../../../schedule/services/schedule-dialog.service";
import {ScheduleService} from "../../../schedule/services/schedule-service.service";
import {BranchesService} from "../../services/branches-service.service";
import {BranchModel} from "../../models/branch.model";

export class BrcnahScheduleViewCtrl implements IController {

  branch: BranchModel;
  from: any;
  to: any;
  schedule: any;
  selectedTemplate: any;

  private zoneId: string;
  private dateFormat: any;
  private columnFormat: any;

  private views: any;
  private canCreate: boolean;
  private canUpdate: boolean;
  private canDelete: boolean;
  private events: any;

  constructor(private scheduleDialogService: ScheduleDialogService, private confirmDialogService: ConfirmDialogService,
              private splitService: SplitService, private $q: IQService, private commonsService: CommonsService,
              private commonsDialogService: CommonsDialogService, private IAMPermissions, private $log,
              private scheduleService: ScheduleService, private branchesService: BranchesService, private moment) {
  }

  $onInit() {
    this.zoneId = this.splitService.getTimeZone();
    this.dateFormat = this.splitService.getDateAndTimeConfig().long;
    this.columnFormat = 'ddd ' + this.dateFormat;

    // ctrl.dateFormat = splitService.getDateAndTimeConfig().long;
    // ctrl.firstDay = splitService.getDateAndTimeConfig().firstDay;
    this.views = ['agendaWeek', 'agendaDay'];

    this.canCreate = this.IAMPermissions.hasPermission('schedule.service.create');
    this.canUpdate = this.IAMPermissions.hasPermission('schedule.service.update');
    this.canDelete = this.IAMPermissions.hasPermission('schedule.service.delete');

    if (!this.schedule) {
      this.schedule = [];
    }

    this.events = this._convertScheduleToEvent(this.schedule);
  }

  // onSelectScheduleTemplate($event) {
  //   this.scheduleDialogService.selectTemplate($event, this.selectedTemplate)
  //     .then((template) => {
  //       this._updateAgentScheduleByTemplate(template);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed');
  //     });
  // }
  //
  // onRemoveTemplate() {
  //   this._updateAgentScheduleByTemplate();
  // }

  onCreateSchedule($event, from, to) {
    this.scheduleDialogService.create($event, from, to, _.get(this.selectedTemplate, 'zoneId', this.zoneId))
      .then((scheduleToCreate) => {
        this._createSchedule(scheduleToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onEditSchedule(scheduleEvent, needToEdit, revertFunc, $event) {
    let eventInstanceFromDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    // var functionRef = scheduleRef.schedule.freq ? scheduleDialogService.selectChangeType($event) : $q.when()
    const functionRef = (scheduleRef.holderType === 'BRANCH' && scheduleRef.schedule.freq) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when()

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        let eventInstanceToDate;
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceFromDate = this.moment(scheduleEvent.start.toISOString()).valueOf();
          eventInstanceToDate = this.moment(scheduleEvent.end.toISOString()).valueOf();
          // eventInstanceFromDate = scheduleEvent.start.valueOf();
          // eventInstanceToDate = scheduleEvent.end.valueOf();
        }

        return needToEdit ? this.scheduleDialogService.edit($event, scheduleRef, eventInstanceFromDate, eventInstanceToDate) : this.$q.when({schedule: scheduleRef});
      })
      .then((editedSchedule) => {
        this._updateOneSchedule(editedSchedule.schedule, changeType, eventInstanceFromDate);
      })
      .catch(() => {
        if (revertFunc) {
          revertFunc();
        }
        this.$log.info('Dialog Closed');
      });
  }

  onDeleteSchedule(scheduleEvent, $event) {
    let eventInstanceDate;
    let changeType;
    const scheduleRef = scheduleEvent.dataRef;
    const functionRef = (scheduleRef.holderType === 'BRANCH' && scheduleRef.schedule.freq) ? this.scheduleDialogService.selectChangeType($event) : this.$q.when();

    functionRef
      .then((selectedChangeType) => {
        // # EVENT # FUTURE # ALL
        changeType = selectedChangeType || 'EVENT';

        if (changeType === 'EVENT' || changeType === 'FUTURE') {
          eventInstanceDate = scheduleEvent.start.valueOf();
        }

        // if (changeType === 'ALL') {
        //     eventInstanceDate = scheduleRef.schedule.startTime;
        // }

        this._deleteSchedule(scheduleRef.id, changeType, eventInstanceDate);
        // _updateOneSchedule(editedSchedule, changeType, eventInstanceDate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

  onViewRender(start, end) {
    const currentStart = start.valueOf();
    const currentEnd = end.valueOf();

    if (this.from !== currentStart || this.to !== currentEnd) {
      this.from = currentStart;
      this.to = currentEnd;

      this._initBranchSchedule(this.branch.id, currentStart, currentEnd)
    }
  }

  onCalendarSelection(from, to, $event) {
    // If only clicked on calendar (less then an full hour)
    if (to.valueOf() - from.valueOf() <= 1800000) {
      return;
    }

    let toTimestamp: number;
    let fromTimestamp: number = from.valueOf();

    if (this.moment(to.valueOf()).get('hour') === 0) {
      toTimestamp = to.valueOf() - 900000;
    } else {
      toTimestamp = to.valueOf();
    }

    this.onCreateSchedule($event, fromTimestamp, toTimestamp);
  }

  onEventClick(event, $event) {

    if (this.moment(event.start).startOf('day').isBefore(this.moment().startOf('day'))) {
      return;
    }

    const actions = _.chain([
      {key: 'Edit', value: this.canUpdate},
      {key: 'Delete', value: this.canDelete}
    ])
      .filter((a) => {
        return a.value;
      })
      .map((a) => {
        return a.key
      })
      .value();

    this.commonsService.openActionPanel(actions, $event)
      .then((reason) => {
        if (reason === 'Edit') {
          this.onEditSchedule(event, true, undefined, $event)
        }
        if (reason === 'Delete') {
          this.onDeleteSchedule(event, $event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onEventChange(event, delta, revertFunc, $event) {

    const oneScheduleCopy = angular.copy(event);

    if (oneScheduleCopy.start.startOf('day').isBefore(this.moment().startOf('day'))) {
      revertFunc();
      return;
    }

    oneScheduleCopy.dataRef.schedule.startTime = this.moment(event.start.toISOString()).valueOf();
    oneScheduleCopy.dataRef.schedule.endTime = this.moment(event.end.toISOString()).valueOf();
    // oneScheduleCopy.dataRef.schedule.startTime = event.start.valueOf();
    // oneScheduleCopy.dataRef.schedule.endTime = event.end.valueOf();

    this.onEditSchedule(oneScheduleCopy, false, revertFunc, $event);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _initBranchSchedule(branchId, from, to) {
    this.scheduleService.getByBranchId(from, to, this.branch.id)
      .then((schedule) => {
        this.schedule = schedule;
        this.events = this._convertScheduleToEvent(schedule);
      })
  }

  // private _updateAgentScheduleByTemplate(template?) {
  //   this.branchesService.selectScheduleTemplate(this.branch.id, _.get(template, 'id'))
  //     .then((updatedTemplate) => {
  //       this.selectedTemplate = template;
  //       this._initAgentSchedule(this.branch.id, this.from, this.to);
  //     })
  // }

  private _createSchedule(schedule) {
    const schedules = _.isArray(schedule) ? schedule : [schedule];
    this.scheduleService.createManyByBranchId(schedules, this.branch.id)
      .then((createdSchedule) => {
        this.schedule = this.schedule.concat(createdSchedule);
        this.events = this._convertScheduleToEvent(this.schedule);
      })
  }

  private _updateOneSchedule(schedule, type, eventInstanceDate) {
    this.scheduleService.updateOneByBranchId(schedule, schedule.id, this.branch.id, type, eventInstanceDate)
      .then((updatedSchedule) => {
        this._initBranchSchedule(this.branch.id, this.from, this.to);
      })
  }

  private _deleteSchedule(scheduleId, type, eventInstanceDate) {
    this.scheduleService.deleteOneByBranchId(scheduleId, this.branch.id, type, eventInstanceDate)
      .then((deletedShift) => {
        this._initBranchSchedule(this.branch.id, this.from, this.to);
      })
  }

  private _convertScheduleToEvent(schedule) {
    if (!schedule) {
      return [];
    }

    return this.scheduleService.parseManyScheduleToEventsByRange(schedule, this.from, this.to, this.branch.id);
  }
}

angular
  .module('bringoz.admin.branches')
  .component('branchScheduleView', {
    bindings: {
      branch: '<',
      from: '<',
      to: '<',
      schedule: '<',
      selectedTemplate: '<?'
    },
    template: require('./branch-schedule-view.html').default,
    controller: BrcnahScheduleViewCtrl
  });
